import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { CarRentalsPage } from './CarRentalsPage';
import YachtRentalsPage from './YachtRentalsPage';
import EnhancedAllBookingsPage from './EnhancedAllBookingsPage';
import { DriverHiresPage } from './DriverHiresPage';
import { VehicleSubstitutionPage } from './VehicleSubstitutionPage';

export const BookingsPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="all" replace />} />
      <Route path="all" element={<EnhancedAllBookingsPage />} />
      <Route path="rentals" element={<CarRentalsPage />} />
      <Route path="yacht-rentals" element={<YachtRentalsPage />} />
      <Route path="driver-hires" element={<DriverHiresPage />} />
      <Route path="substitution" element={<VehicleSubstitutionPage />} />
    </Routes>
  );
};

